export default function AmbientBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      aria-hidden
    >
      <div className="absolute inset-0 bg-background" />
      <div className="absolute inset-0 bg-mesh-light dark:bg-mesh-dark" />
      <div className="absolute inset-0 bg-dot-pattern bg-dot opacity-40 dark:opacity-25" />
      <div
        className="absolute -left-32 top-1/4 h-80 w-80 rounded-full bg-primary/20 blur-3xl animate-blob-safe dark:bg-primary/25"
        aria-hidden
      />
      <div
        className="absolute -right-24 top-1/2 h-96 w-96 rounded-full bg-secondary/15 blur-3xl animate-blob-safe-delayed dark:bg-secondary/20"
        aria-hidden
      />
      <div
        className="absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-accent/10 blur-3xl animate-blob-safe dark:bg-accent/15"
        aria-hidden
      />
    </div>
  );
}
